import { MessageService } from "../services/message.service";
import { Message } from "../common/message";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";
import { EngineService } from "../services/engine.service";
import { Engine } from "../models/engine";
import { PowertrainService } from "../services/powertrain.service";

let ELEMENT_DATA = [];

@Component({
  selector: "app-engine",
  templateUrl: "./engine.component.html",
  styleUrls: ["./engine.component.scss"],
})
export class EngineComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "SN",
    "name",
    "alias",
    "startDate",
    "code",
    "powertrainId",
    "status",
    "hoursread",
    "lastHoursread",
    "prevLastHoursread",
    "lastOrder",
    "actions",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  resource: Engine = new Engine();

  constructor(
    private dialog: MatDialog,
    private ptService: PowertrainService,
    private service: EngineService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    //this.resource = new Engine();
    this.setMessageForm();
    this.getResources();
    this.getPowertrains();
  }

  getPowertrains() {
    this.powerTrains = [];
    this.ptService.getAll().subscribe((result) => {
      this.powerTrains = this.powerTrains.concat(result);
    });
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      code: ["", Validators.required],
      powertrain: ["", Validators.required],
      status: ["", Validators.required],
      hoursread: ["", Validators.required],
      lasthoursread: [""],
      prevlasthoursread: [""],
      lastorder: [""],
      startDate: ["", Validators.required],
      alias: ["", Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    //this.resource = new Engine();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave() {
    this.submitted = true;

    if (!this.resource || this.resource.name.trim() == "") {
      return;
    }

    if (this.form.controls.status.errors) {
      return;
    }

    if (this.form.controls.hoursread.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement();
    } else {
      if (this.checkIfPowerTrainHasTwoMotors()) return;
      this.addElement();
    }
  }

  checkIfPowerTrainHasTwoMotors() {
    // check if powercoach contain more than 2 engines
    for (let pt of this.powerTrains) {
      if (this.resource.powertrainId == pt.id) {
        if (pt.motors && pt.motors.length >= 2) {
          this.msg.alert("تم اضافة محركان لهذه العربة");
          return true;
        }
      }
    }
  }

  pushTheNewMotorToItsPowerCoachEnginesList(motor: any) {
    for (let pt of this.powerTrains) {
      if (motor.powertrainId == pt.id) {
        pt.motors.push(motor);
      }
    }
  }

  resetForm(ret?: boolean) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement() {
    this.service.create(this.resource).subscribe((result: any) => {
      this.pushTheNewMotorToItsPowerCoachEnginesList(result);
      this.msg.alert(Message.SAVE);
      result.powertrain = this.getPowerTrainById(result.powertrainId);
      ELEMENT_DATA.push(result);
      this.updateDataSource();
      this.resetForm();
    });
  }

  updateElement() {
    this.service.update(this.resource).subscribe((result: any) => {
      this.msg.alert(Message.UPDATE);
      result.powertrain = this.getPowerTrainById(result.powertrainId);
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id === this.resource.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });

      this.updateDataSource();
      this.resetForm(true);
    });
  }

  editElement(ele: Engine) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setCode(ele.code);
    this.resource.setDesc(ele.desc);
    this.resource.setPowertrainId(ele.powertrainId);
    this.resource.setStatus(ele.status);
    this.resource.setHoursread(ele.hoursread);
    this.resource.setLastHoursread(ele.lastHoursread);
    this.resource.setPrevLastHoursread(ele.prevLastHoursread);
    this.resource.setLastOrder(ele.lastOrder);
    this.resource.setStartDate(ele.startDate);
    this.resource.setAlias(ele.alias);
  }

  getPowerTrainById(id: string) {
    for (let obj of this.powerTrains) {
      if (obj.id == id) {
        return obj;
      }
    }
  }

  deleteElement(ele) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
          });
        } else {
          return;
        }
      });
  }
}
